import type { TranslationKey } from "../locales";
import type { Enums, Nullable } from "../types";

export function getAttendanceWorksiteTranslationKey(
	type: Nullable<Enums<"attendanceWorksiteType">>,
): TranslationKey {
	switch (type) {
		case "home-office":
			return "users.worksite_type.home_office";
		case "office":
			return "users.worksite_type.office";
		case "project-site":
			return "users.worksite_type.project_site";
		case "warehouse":
			return "users.worksite_type.warehouse";
		case "commute":
			return "users.worksite_type.commute";
		default:
			return "general.unknown";
	}
}
